import React, { ReactElement } from 'react';
import { AppError } from 'utils/AppError';
import Errors from 'components/ui/Form/Errors';
import { Box, Text, Button, RefreshIcon, IconComponent } from '@razorpay/blade/components';
import { getStaticMediaUrl } from 'utils/Urls';
import failedToLoad from 'assets/network-error.svg';

export const ErrorCard = ({
  error,
  buttonText = 'Refresh Page',
  onClick = () => {
    window.location.reload();
  },
  showErrors = true,
  buttonIcon = RefreshIcon,
}: {
  error: typeof AppError;
  buttonText?: string;
  onClick?: () => void;
  showErrors?: boolean;
  buttonIcon?: IconComponent;
}): ReactElement => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      backgroundColor="surface.background.gray.intense"
      padding="spacing.7"
      borderRadius="large">
      <img
        width="150px"
        height="150px"
        src={getStaticMediaUrl(failedToLoad)}
        alt="Failed to load"
      />
      <Text
        size="large"
        weight="semibold"
        textAlign="center"
        marginTop="spacing.7"
        marginBottom="spacing.3">
        Uh Oh! An Error has occurred.
      </Text>
      <Text
        size="medium"
        weight="regular"
        color="surface.text.gray.muted"
        textAlign="center"
        marginBottom="spacing.7">
        {showErrors ? (
          <Errors errorResponse={error} />
        ) : (
          'This page could not be loaded due to unknown error. Try refreshing the page or try again after sometime.'
        )}
      </Text>
      <Box display="flex" justifyContent="center" gap="spacing.5">
        <Button variant="tertiary" href="mailto:xpayroll@razorpay.com">
          Contact Support
        </Button>
        <Button variant="secondary" icon={buttonIcon} iconPosition="left" onClick={onClick}>
          {buttonText}
        </Button>
      </Box>
    </Box>
  );
};
